import { Buffer } from 'buffer';
(globalThis as { Buffer?: typeof Buffer }).Buffer ??= Buffer;

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './App';
import { applyConsentToAnalytics } from './components/CookieBanner';

// Re-apply the user's stored cookie-consent decision into gtag on every
// boot. Without this, a returning 'accepted' user would still be on the
// page-default 'denied' until they interacted with something that
// re-triggered the banner (which they wouldn't — the banner self-hides
// after a decision). Idempotent: gtag just keeps the latest signal.
applyConsentToAnalytics();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
